import React, { useCallback, useEffect, useState } from 'react';
import {FileUploading} from "@/services/models/file-uploading";


export default function fileNamed(fileExt: string, filename?: string, status?:string, progress?:number){

    function getColorForExtension(ext:string) {
        // Convert to lowercase for consistent comparison
        const extension = ext.toLowerCase();

        // Color mapping for different file types
        const colorMap: { [key: string]: string } = {
            // Document formats
            'pdf': 'text-red-600',
            // Presentations
            'ppt': 'text-orange-600',
            'pptx': 'text-orange-600',
            // Word documents
            'doc': 'text-blue-700',
            'docx': 'text-blue-700',
            // Excel spreadsheets
            'xls': 'text-green-700',
            'xlsx': 'text-green-700',
            // Web and data formats
            'html': 'text-purple-600',
            'csv': 'text-green-600',
            'json': 'text-yellow-600',
            'xml': 'text-blue-400',
            // Text formats
            'txt': 'text-gray-500',
            'md': 'text-indigo-600',
        };

        if(status === 'error')
            return 'text-red-600'

        // Return the color class or default blue if extension not found
        return colorMap[extension] || 'text-blue-500';
    }

    function getShortFilename(filename:string) {
        if (!filename) return '';

        const lastDotPosition = filename.lastIndexOf('.');
        if (lastDotPosition === -1) return filename;

        const nameWithoutExtension = filename.substring(0, lastDotPosition);
        return nameWithoutExtension;
    }


    // Get the appropriate color class
    const colorClass = getColorForExtension(fileExt);
    const isLoading = status === 'uploading'

    // Shimmer effect styles for background
    const shimmerBgStyle = "relative overflow-hidden";
    const transitionClass = "transition-all duration-300 ease-in-out";


    return (
        <div className="flex flex-col items-center w-full">
            {/* File icon container */}
            <div className="relative mb-2">
                {/* Custom SVG file icon - with conditional shimmer effect */}
                <div className={isLoading ? `${colorClass} opacity-60` : colorClass}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className={isLoading ? shimmerBgStyle : ""}
                    >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        {isLoading && (
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-30 animate-shimmer"></div>
                        )}
                    </svg>
                </div>

                {/* Extension text overlay - with conditional shimmer */}
                <div className="absolute inset-0 flex items-center justify-center pt-4">
          <span className={`font-bold ${isLoading ? 'text-gray-500' : 'text-gray-700'} uppercase ${fileExt.length > 3 ? 'text-xs' : 'text-sm'} ${isLoading ? shimmerBgStyle : ''}`}>
            {fileExt}
              {isLoading && (
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-40 animate-shimmer"></div>
              )}
          </span>
                </div>
            </div>

            {/* Filename display - using span instead of p to avoid nesting issues */}
            {filename && (
                <div className="text-center w-full">
          <span className={`block text-sm ${isLoading ? 'text-gray-500' : status === 'error'? 'text-red-600':'text-gray-800'} font-medium truncate max-w-full px-2 ${isLoading ? shimmerBgStyle : ''}`} title={filename}>
            {filename.length > 30 ? filename.substring(0, 27) + '...' : filename}
              {isLoading && (
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-60 animate-shimmer"></div>
              )}
          </span>
                </div>
            )}
        </div>
    );
};